import { Switch } from '@ui/kit';
import { textCorrectionInput } from '@utils/component-framework';
import { useOpgavekompleksetEntry } from '../../../../state/hook.entry.js';
import { useUpdateInputMutation } from '../../../../state/mutations/update-input.js';
import { switchLabel } from './atom.start-comma.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function StartCommaInput(props) {
  const update = useUpdateInputMutation();
  const inputEntry = useOpgavekompleksetEntry({
    select: entry => textCorrectionInput.entry.asType(entry?.data.tasks[props.taskEntryKey]?.details[props.input.id])
  });
  const onChange = () => {
    update(props.taskEntryKey, props.input.id, prev => ({
      type: "text-correction",
      text: props.input.initialText,
      ...prev,
      validationType: prev?.validationType === "without-start-comma" ? "with-start-comma" : "without-start-comma"
    }));
  };
  return /*#__PURE__*/jsxs("label", {
    className: switchLabel,
    children: [/*#__PURE__*/jsx("p", {
      children: !inputEntry || inputEntry.validationType === "with-start-comma" ? "Med startkomma" : "Uden startkomma"
    }), /*#__PURE__*/jsx(Switch, {
      checked: !inputEntry || inputEntry.validationType === "with-start-comma",
      onChange: onChange
    })]
  });
}

export { StartCommaInput };
//# sourceMappingURL=atom.start-comma.js.map
